import React from 'react'
import {NavLink} from 'react-router-dom'

const SignedInLink = () =>{
  return (
    <ul className="right">
        <li><NavLink to='/'>Home</NavLink></li>
        <li><NavLink to='/reports'>Reports</NavLink></li>
        <li><NavLink to='/'>Log Out</NavLink></li>
        <li><NavLink to='/' className ='btn btn-floating pink lighten-1'>WX</NavLink></li>
    </ul>
  )
}

export default SignedInLink